import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import { SET_PERMISSIONS, SET_PERMISSIONS_ERROR } from '../constants/permissions.constants';
var DEFAULT_STATE = {
  permissions: EMPTY_ARRAY,
  success: false,
  loaded: false
};
export default function permissionsState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SET_PERMISSIONS:
      {
        var payload = action.payload;
        var permissions = payload.permissions,
          success = payload.success;
        return {
          permissions: permissions,
          success: success === 'success',
          loaded: true
        };
      }
    case SET_PERMISSIONS_ERROR:
      {
        return {
          permissions: EMPTY_ARRAY,
          success: false,
          loaded: true
        };
      }
    default:
      return state;
  }
}